// eslint-disable-next-line no-restricted-imports
import _axios from 'axios';

export const axios = _axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});

// Add build information to all requests
axios.interceptors.request.use((config) => {
  // Get build information injected at build time
  const buildInfo = __BUILD_INFO__;

  // Add build info to query parameters
  if (!config.params) {
    config.params = {};
  }

  // Add git commit hash and build date+time for tracking
  config.params._commit = buildInfo.gitHash;


  config.headers['X-Build-Info'] = buildInfo.gitHash;
  config.headers['X-Build-Date'] = buildInfo.buildDateTime;
  return config;
}, (error) => {
  return Promise.reject(error);
});
